window.dataLayer = window.dataLayer || [];
// eslint-disable-next-line prefer-rest-params
window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };
